
























import { Component, Vue, Prop } from "vue-property-decorator";

const CONTAINER_ID = "dropdown-popup-container";

@Component
export default class DropdownList extends Vue {
  @Prop({ default: "" }) private title?: string;
  @Prop() private value?: any;
  @Prop({ default: () => (item: any) => item }) private valueLabel!: (
    value: any
  ) => any;
  @Prop({ default: () => [] }) private options!: any[];
  @Prop({ default: null }) private nullOption?: string;
  @Prop({ default: "Select..." }) private placeholder?: string;
  @Prop({ default: () => false }) private disabled!: boolean;

  display(value: any | null) {
    if (!value) {
      return this.nullOption || this.placeholder || "";
    }
    if (value && this.valueLabel(value)) {
      return this.valueLabel(value);
    }
    if (this.options.length) {
      return this.valueLabel(this.options[0]) || "";
    }
    return "";
  }

  handleButtonClicked() {
    const options = this.nullOption ? [null, ...this.options] : this.options;
    this.createPopupMenu(options);
  }

  createPopupMenu(options: any[]) {
    const position = this.$refs.position
      ? (this.$refs.position as HTMLElement).getBoundingClientRect()
      : null;
    const button = this.$refs.button
      ? (this.$refs.button as HTMLElement).getBoundingClientRect()
      : null;
    if (!position || !button) {
      return;
    }
    if (!document.getElementById(CONTAINER_ID)) {
      const element = document.createElement("div");
      element.id = CONTAINER_ID;
      document.body.appendChild(element);
    }
    const popupContainer = document.getElementById(CONTAINER_ID);
    if (!popupContainer) {
      return;
    }
    const { left, top } = position;
    const { width } = button;
    popupContainer.className = "dropdown-popup-container md-elevation-4";
    popupContainer.style.cssText = `left:${left}px;top:${top +
      document.body.scrollTop}px;min-width:${width}px;`;
    popupContainer.innerHTML = "";
    const clickOut = document.createElement("div");
    clickOut.className = "dropdown-popup-clickout";
    clickOut.addEventListener("mousedown", () => {
      this.clearPopupMenu();
    });
    clickOut.addEventListener("mousewheel", () => {
      this.clearPopupMenu();
    });
    popupContainer.appendChild(clickOut);
    const popupContent = document.createElement("div");
    popupContent.className = "dropdown-popup-content";
    popupContainer.appendChild(popupContent);
    options.forEach(option =>
      this.addMenuOptionToContainer(popupContent, option)
    );
  }

  addMenuOptionToContainer(container: HTMLElement, option: any) {
    const menuItem = document.createElement("div");
    menuItem.className = "dropdown-list-item";
    menuItem.innerText = this.display(option);
    menuItem.addEventListener("click", event => {
      this.handleItemSelected(option);
    });
    container.appendChild(menuItem);
  }

  clearPopupMenu() {
    const popupContainer = document.getElementById(CONTAINER_ID);
    if (popupContainer instanceof HTMLElement) {
      popupContainer.remove();
    }
  }

  handleItemSelected(item: any) {
    this.clearPopupMenu();
    this.$emit("change", item);
  }
}
